import wapindex from "@/views/wap/index/Index";
const wapRouters = [
  {
    path: "index",
    name: "wap-index",
    meta: {
      title: "首页--中国智慧农贸领军企业 "
    },
    //component: () => import('@/views/wap/index/Index'),
    component: wapindex
  },
  {
    path: "company-profile",
    name: "wap-company-profile",
    meta: {
      title: "关于沃沃 | 沃沃农贸"
    },
    component: () => import("@/views/wap/companyProfile/CompanyProfile")
  },
  {
    path: "solution",
    name: "wap-solution",
    meta: {
      title: "解决方案 | 沃沃农贸",
      keepAlive: true
    },
    component: () => import("@/views/wap/solution/Solution")
  },
  {
    path: "solution-show",
    name: "wap-solution-show",
    meta: {
      title: "详情 | 沃沃农贸"
    },
    component: () => import("@/views/wap/solution/SolutionShow")
  },
  {
    path: "successful-cases",
    name: "wap-successful-cases",
    meta: {
      title: "经典案例 | 沃沃农贸",
      keepAlive: true
    },
    component: () => import("@/views/wap/successfulCases/SuccessfulCases")
  },
  {
    path: "successful-cases-show",
    name: "wap-successful-cases-show",
    meta: {
      title: "详情 | 沃沃农贸"
    },
    component: () => import("@/views/wap/successfulCases/SuccessfulCasesShow")
  },
  {
    path: "products",
    name: "wap-products",
    meta: {
      title: "产品服务 | 沃沃农贸",
      keepAlive: true
    },
    component: () => import("@/views/wap/product/Products")
  },
  {
    path: "news",
    name: "wap-news",
    meta: {
      title: "新闻中心 | 沃沃农贸",
      keepAlive: true
    },
    component: () => import("@/views/wap/news/News")
  },
  {
    path: "news-show",
    name: "wap-news-show",
    meta: {
      title: "详情 | 沃沃农贸"
    },
    component: () => import("@/views/wap/news/NewsShow")
  },
  {
    path: "contact-us",
    name: "wap-contact-us",
    meta: {
      title: "联系我们 | 沃沃农贸"
    },
    component: () => import("@/views/wap/contactUs/ContactUs")
  },
  {
    path: "qualification-and-honors",
    name: "wap-qualification-and-honors",
    meta: {
      title: "资质荣誉 | 沃沃农贸"
    },
    component: () =>
      import("@/views/wap/qualificationAndHonors/QualificationAndHonors")
  },
  {
    path: "application",
    name: "wap-application",
    meta: {
      title: "应用产品 | 沃沃农贸"
    },
    component: () => import("@/views/wap/application/Application")
  },
  {
    path: "recruit",
    name: "wap-recruit",
    meta: {
      title: "人才招聘 | 沃沃农贸"
    },
    component: () => import("@/views/wap/recruit/Index")
  },
  {
    path: "supply-chain",
    name: "wap-supply-chain",
    meta: {
      title: "供应链 | 沃沃农贸"
    },
    component: () => import("@/views/wap/supplyChain/SupplyChain")
  },
  {
    path: "join",
    name: "wap-join",
    meta: {
      title: "加盟 | 沃沃农贸"
    },
    component: () => import("@/views/wap/join/Join")
  },
  {
    path: "/social-responsibility",
    name: "wap-social-responsibility",
    meta: {
      title: "社会责任 | 沃沃农贸"
    },
    component: () =>
      import("@/views/wap/socialResponsibility/socialResponsibility")
  }
];
// 重新组织后导出
export default [...wapRouters];



// WEBPACK FOOTER //
// ./src/router/wap.js